import { ICommonLink } from '@src/models/common';

export const ADVANTAGES: ICommonLink = {
  id: 'advantagesLink',
  disableNextJs: true,
  href: '/#advantages',
  name: 'Преимущества',
};

export const TRY: ICommonLink = {
  id: 'tryLink',
  disableNextJs: true,
  href: '/#try',
  name: 'Как начать',
};

export const FAQ: ICommonLink = {
  id: 'faqLink',
  disableNextJs: true,
  href: '/#questions',
  name: 'FAQ',
};

export const OPPORTUNITIES: ICommonLink = {
  id: 'opportunitiesLink',
  disableNextJs: true,
  href: '/#opportunities',
  name: 'Возможности',
};

export const PRICING: ICommonLink = {
  id: 'pricingLink',
  disableNextJs: true,
  href: '/pricing',
  name: 'Тарифы',
};

export const PRIVACY: ICommonLink = {
  href: 'https://centra.ai/privacy.pdf',
  name: 'Политика конфиденциальности',
  id: 'policyLink',
  target: '_blank',
  disableNextJs: true,
};

export const OFFER: ICommonLink = {
  href: 'https://centra.ai/offer.pdf',
  name: 'Оферта',
  id: 'offerLink',
  target: '_blank',
  disableNextJs: true,
};

export const OFFER_EDUCATION: ICommonLink = {
  href: 'https://centra.ai/offer_education.pdf',
  name: 'Оферта для образования',
  id: 'offerEducationLink',
  target: '_blank',
  disableNextJs: true,
};

export const MARKETING_OFFER: ICommonLink = {
  href: 'https://centra.ai/accept_marketing_offer.pdf',
  name: 'Согласие на получение рекламной рассылки',
  id: 'marketingOfferLink',
  target: '_blank',
  disableNextJs: true,
};
